import React from 'react';
import { APP_VERSION } from '../constants/version';

const VersionDisplay: React.FC = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-sm py-2 px-4 text-center border-t border-gray-200">
      <p className="text-xs text-gray-500">
        Versión {APP_VERSION}
      </p>
    </div>
  );
};

export default VersionDisplay;
